import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import store from './store';
import BootstrapActions from './actions/bootstrap';
import Login from './views/Login';
import Order from './views/Order';
import Root from './views/Root';
import UnknownUser from './views/UnknownUser';
import MapJoyride from './components/Joyride';
import NewUserModal from './components/Modals/NewUserModal';
import PrintableTransaction from './components/PrintableTransaction';

import 'react-select-plus/dist/react-select-plus.css';
import './map-min.css';
import './main.scss';
import SiteActions from './actions/sites';
import Downtime from './views/Downtime';

export default class MapApp extends Component {
    constructor() {
        super();
        this.state = { router: null };
    }

    componentDidMount() {
        store.dispatch(BootstrapActions.bootstrapApp());
        // store.dispatch(SiteActions.fetchSitesForUserAccount());
        // store.dispatch(SiteActions.fetchSites());
    }

    _adminRedirect() {
        const adminUrl = window.location.href.replace(
            /advantage\.sw\.siemens/g,
            'advantage-admin.sw.siemens'
        );
        window.location = adminUrl;
        return <span>loading...</span>;
    }

    render() {
        return (
            <Provider store={store}>
                <div>
                    <div className="hidden-print">
                        <BrowserRouter ref={(r) => {
                                // I know, I know :(
                                if (!this.state.router) {
                                    this.setState({ router: r });
                                }
                            }}
                            basename="/" >
                            <Switch>
                                <Route path="/login" component={Login} exact={true} />
                                {/* <Route path='/checkout' component={Checkout} exact={true} /> */}
                                <Route path="/order" component={Order} exact={true} />
                                <Route path="/unknown-user" component={UnknownUser} exact={true} />
                                <Route path="/admin" render={() => this._adminRedirect()} />
                                <Route path="/maintenance" component={Downtime} exact={true} />
                                <Route path="/" component={Root} />
                            </Switch>
                        </BrowserRouter>
                        <MapJoyride router={this.state.router} />
                        <NewUserModal />
                    </div>
                    <div className="visible-print-block">
                        <PrintableTransaction />
                    </div>
                </div>
            </Provider>
        );
    }
}



// WEBPACK FOOTER //
// ./app/MapApp.jsx